// Cspell:ignore CRST
export const SHIPMENT_TABLE_COLUMN_NAME = {
  PRO: "PRO",
  PALLETS_AND_PIECES: "Plts | Pcs",
  HANDLING_UNITS: "HU",
  WEIGHT: "Weight",
  SERVICE_DUE: "Service Due",
  SHIPPER: "Shipper Name",
  STOP_SEQ: "Stop Sequence",
  CONSIGNEE_NAME: "Consignee Name",
  CONSIGNEE_ADDRESS: "Consignee Address",
  CONSIGNEE_CITY: "Consignee City",
  CONSIGNEE_ZIP: "Consignee Zip",
  DEST_SIC: "Dest SIC",
  TAGS: "Shipment Tags",
  STATUS: "Status",
  LOCATION: "Location",
  APPOINTMENT_MADE: "Appt Date",
  ETA: "ETA",
  ASSIGNMENT: "Assignment",
};

export const STATIC_LOAD_TEMPLATE_TABLE_HEADERS = [
  { name: "Door", id: "DoorId" },
  { name: "Door Type", id: "DoorType" },
  { name: "Lane Load To", id: "LaneId" },
  { name: "Cut Time", id: "CutTime" },
];

export const LOAD_TEMPLATE_TABLE_HEADERS = [
  { name: "Template Name", id: "Name" },
  { name: "Default", id: "IsDefault" },
];
